import React, { useEffect, useState } from "react";
import apiClient from "../../utils/apiclient";

export default function OrderDashboard() {
const [dashboardData, setDashboardData] = useState({
  kitchens: [],
  timeWiseOrders: [],
});
  const [restaurants, setRestaurants] = useState([]);

  const [loading, setLoading] = useState(false);

const [filters, setFilters] = useState({
  restaurantId: "",
  date: new Date().toISOString().split("T")[0],
  mealType: "ALL",
  dashboardType: "TIME_WISE",
});

  // ================= FETCH DASHBOARD =================

  const fetchDashboard = async () => {
    try {
      setLoading(true);

      const params = new URLSearchParams();

      if (filters.restaurantId) {
        params.append("restaurantId", filters.restaurantId);
      }

      if (filters.date) {
        params.append("date", filters.date);
      }

      params.append("mealType", filters.mealType);
      params.append(
  "dashboardType",
  filters.dashboardType
);
const response = await apiClient.get(`/order-dashboard?${params.toString()}`)
      

console.log( response.data);

      setDashboardData(response.data);
    } catch (error) {
      console.error("Dashboard Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // ================= FETCH RESTAURANTS =================

  const fetchRestaurants = async () => {
    try {
        const response = await apiClient.get("/restaurant");
        console.log(response);
        


      setRestaurants(response.data);
    } catch (error) {
      console.error("Restaurant Error:", error);
    }
  };

  // ================= INITIAL LOAD =================

  useEffect(() => {
    fetchRestaurants();
    fetchDashboard();
  }, []);

  // ================= CARD RENDER =================


  // ================= UI =================
const sortedTimeWiseOrders = [...(dashboardData.timeWiseOrders || [])]
  .sort((a, b) => {

    // 1. Restaurant sorting
    const restaurantCompare =
      a.restaurantName.localeCompare(
        b.restaurantName
      );

    if (restaurantCompare !== 0) {
      return restaurantCompare;
    }

    // 2. Time sorting
    const getHour = (slot) => {
      return Number(slot.split(':')[0]);
    };

    return getHour(a.slot) - getHour(b.slot);
  });
  return (
    <div className="flex flex-1 flex-col overflow-hidden px-2 md:px-4">
      {/* HEADER */}
      <h1 className="text-xl font-bold text-gray-800 flex-shrink-0 mt-4 mb-2">
        Order Dashboard
      </h1>

      {/* FILTERS */}
    <div className="bg-white border border-gray-300 rounded-lg shadow-sm p-2 md:p-3 mb-2 flex-shrink-0 grid grid-cols-2 md:flex md:flex-row gap-2 md:gap-3 items-center w-full">
        {/* Restaurant Dropdown */}
        <select
          value={filters.restaurantId}
          onChange={(e) =>
            setFilters({
              ...filters,
              restaurantId: e.target.value ? Number(e.target.value) : "",
            })
          }
          className="border-2 py-1 px-2 md:py-2 md:px-4 text-xs md:text-base rounded-lg outline-none focus:border-blue-500 w-full col-span-2 md:col-span-1"
        >
          <option value="">All Restaurants</option>

          {restaurants.map((restaurant) => (
            <option
              key={restaurant.id}
              value={restaurant.id}
            >
              {restaurant.name}
            </option>
          ))}
        </select>

        {/* Date */}
        <input
          type="date"
          value={filters.date}
          onChange={(e) =>
            setFilters({
              ...filters,
              date: e.target.value,
            })
          }
          className="border-2 py-1 px-2 md:py-2 md:px-4 text-xs md:text-base rounded-lg outline-none focus:border-blue-500 w-full col-span-1"
        />

       

        {/* Meal Type Dropdown */}
        <select
          value={filters.mealType}
          onChange={(e) =>
            setFilters({
              ...filters,
              mealType: e.target.value,
            })
          }
          className="border-2 py-1 px-2 md:py-2 md:px-4 text-xs md:text-base rounded-lg outline-none focus:border-blue-500 w-full col-span-1"
        >
          <option value="ALL">ALL</option>
          <option value="BREAKFAST">BREAKFAST</option>
          <option value="LUNCH">LUNCH</option>
          <option value="DINNER">DINNER</option>
        </select>
        <select
          value={filters.dashboardType}
          onChange={(e) =>
            setFilters({
              ...filters,
              dashboardType: e.target.value,
            })
          }
          className="border-2 py-1 px-2 md:py-2 md:px-4 text-xs md:text-base rounded-lg outline-none focus:border-blue-500 w-full col-span-1"
        >
  <option value="OVERVIEW">
    OVERVIEW
  </option>

  <option value="TIME_WISE">
    TIME WISE
  </option>
</select>
        {/* Apply Button */}
        <button
          onClick={fetchDashboard}
          className="bg-blue-600 hover:bg-blue-700 transition text-white rounded-lg px-2 py-1.5 md:px-6 md:py-2 text-xs md:text-base font-semibold w-full col-span-1"
        >
          Apply Filters
        </button>
      </div>

      {/* LOADING */}
      {loading ? (
  <h2 className="text-xl font-semibold">
    Loading...
  </h2>
) : (
  <>
    {/* ================= TIME WISE ================= */}

    {filters.dashboardType === "TIME_WISE" ? (
      <div className="w-full flex-1 flex flex-col min-h-0 mt-2">
        <h2 className="text-lg font-bold mb-2 flex-shrink-0 text-gray-800">
          Time Wise Orders
        </h2>

        <div className="w-full flex-1 overflow-auto pb-4 relative">
          <table className="min-w-max w-full bg-white shadow-md border-collapse">
            <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
              <tr>
                <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center whitespace-nowrap">Restaurant</th>
                <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center whitespace-nowrap">Time Slot</th>
                <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center whitespace-nowrap">Total Orders</th>
                <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center whitespace-nowrap">Ordered</th>
                <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center whitespace-nowrap">Rider Assigned</th>
                <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center whitespace-nowrap">On The Way</th>
                <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center whitespace-nowrap">Delivered</th>
              </tr>
            </thead>

            <tbody>
             
{dashboardData.timeWiseOrders?.length === 0 && (
  <tr>
    <td
      colSpan="6"
      className="text-center p-6 text-gray-500"
    >
      No time wise orders found
    </td>
  </tr>
)}
              {sortedTimeWiseOrders.map(
                (item, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-300 hover:bg-gray-50"
                  >
                    <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{item.restaurantName}</td>
                    <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{item.slot}</td>
                    <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{item.totalOrders}</td>
                    <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{item.ordered}</td>
                    <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{item.riderAssigned}</td>
                    <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{item.onTheWay}</td>
                    <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{item.delivered}</td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div>
    ) : (
      /* ================= KITCHEN SUMMARY ================= */

      <div className="w-full flex-1 flex flex-col min-h-0 mt-2">
        <h2 className="text-lg font-bold mb-2 flex-shrink-0 text-gray-800">
          Kitchen Summary
        </h2>

        <div className="w-full flex-1 overflow-auto pb-4 relative">
          <table className="min-w-max w-full bg-white shadow-md border-collapse">
            <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
              <tr>
                <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center whitespace-nowrap">Kitchen</th>
                <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center whitespace-nowrap">Total Orders</th>
                <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center whitespace-nowrap">Payment Initiated</th>
                <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center whitespace-nowrap">Payment Cancelled</th>
                <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center whitespace-nowrap">Refunded</th>
                <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center whitespace-nowrap">Cancelled</th>
              </tr>
            </thead>

            <tbody>
                {dashboardData.kitchens?.length === 0 && (
  <tr>
    <td
      colSpan="6"
      className="text-center p-6 text-gray-500"
    >
      No kitchen data found
    </td>
  </tr>
)}
              {dashboardData.kitchens?.map(
                (item, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-300 hover:bg-gray-50"
                  >
                    <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{item.kitchenName}</td>
                    <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{item.totalOrders}</td>
                    <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{item.paymentInitiated}</td>
                    <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{item.paymentCancelled}</td>
                    <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{item.refunded}</td>
                    <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{item.cancelled}</td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div>
    )}
  </>
)}
    </div>
  );
}

